// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolCreateOptionsBody = {};

export type typePoolCreateOptionsOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestTypes: {
      contestType: "survivor" | "squares" | "stripCard" | "pickem";
      name: string;
      description: string;
      isAvailable: boolean;
      leagueKeys?: string[] | null;
      allowsCustomLeague?: boolean;
    }[];
    joinPolicies: {
      joinPolicy: "open" | "approval";
      name: string;
      description: string;
    }[];
    seasonYears: number[];
    defaultSeasonYear: number;
  };
};

export type typePoolCreateOptionsOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolCreateOptionsOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolCreateOptionsOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolCreateOptionsBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolCreateOptions(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolCreateOptionsBody);
  }

  return async function postPoolCreateOptions(
    payload: typePoolCreateOptionsBody,
  ): Promise<typePoolCreateOptionsOutput200 | typePoolCreateOptionsOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolCreateOptions" failed before calling the network. #2cbd7c2a4274`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2cbd7c2a4274" },
        },
        data: null,
      } as typePoolCreateOptionsOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/create-options`,
      httpMethod: "POST",
      options,
    })) as typePoolCreateOptionsOutput200 | typePoolCreateOptionsOutput400;
  };
}
